import React from 'react'
import { Link } from 'react-router-dom'
import { useTheme } from '../hooks/use-theme'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  /** When set, logo renders as Link (breakroom-champions style). */
  to?: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

const sizeClasses = {
  sm: 'h-5 xs:h-6 sm:h-6 md:h-7 lg:h-8 w-auto max-h-10',
  md: 'h-6 xs:h-7 sm:h-8 md:h-8 lg:h-9 w-auto max-h-12',
  lg: 'h-8 xs:h-9 sm:h-10 lg:h-12 xl:h-14 w-auto max-h-16',
} as const

const Logo: React.FC<LogoProps> = ({ size = 'md', className = '', to, onClick }) => {
  const { theme } = useTheme()
  const logoSrc = theme === 'dark' ? '/brc-logo-dark-mode.png' : '/brc-logo-light-mode.png'

  const image = (
    <img
      src={logoSrc}
      alt="breakroom"
      className={`object-contain object-left ${sizeClasses[size]}`.trim()}
      loading="eager"
      fetchPriority="high"
    />
  )

  const cls = `flex items-center shrink-0 ${className}`.trim()
  if (to !== undefined) {
    return (
      <Link to={to} onClick={onClick} className={cls} aria-label="breakroom home">
        {image}
      </Link>
    )
  }
  return <span className={cls}>{image}</span>
}

export default Logo
